import React from 'react';
import { Step as MuiStep, withStyles } from '@material-ui/core';
var StyledStep = withStyles({
  root: {
    minWidth: '216px'
  }
})(MuiStep);
export function Step(props) {
  return /*#__PURE__*/React.createElement(StyledStep
  // I don't really like this but we probably have to use prop spread here
  // because MUI injects some props into Step and it's not documented
  , props);
}